import { Link, useParams, useNavigate } from 'react-router-dom';
import { useContract, useSimulation } from '../api/hooks';
import { SimulationCard } from './authorised/SimulationCard';

export function SimulationPage() {
  const navigate = useNavigate();
  const { simulationId = '' } = useParams();
  const simulation = useSimulation(simulationId);
  const contract = useContract(simulation.data?.contractId);
  return (
    <div className="simulation-page">
      <Link className="simulation-back" to="/authorised-contracts">
        ← Authorised contracts
      </Link>
      <header className="simulation-heading">
        <p className="simulation-eyebrow">ROYALTY CALCULATIONS</p>
        <h1>Simulation workspace</h1>
        <p>
          {contract.data?.title ??
            'Review the reporting period, follow each level and export a statement.'}
        </p>
      </header>
      {simulation.isLoading && <p role="status">Loading simulation…</p>}
      {simulation.isError && (
        <p role="alert">
          This simulation could not be loaded. Return to authorised contracts and try again.
        </p>
      )}
      {simulation.data && (
        <SimulationCard
          key={simulationId}
          simulation={simulation.data}
          onDeleted={() => navigate('/authorised-contracts')}
        />
      )}
    </div>
  );
}
